export default "__VITE_ASSET__cd10397f__";